import styled from 'styled-components';

export const Root = styled.div`
  position: fixed;
  right: 36px;
  bottom: 128px;
`;
